import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import CalendarPanel from './CalendarPanel';
// Стилі підключені тут, а не лише в панелі: кнопка живе в шапці постійно,
// а панель монтується тільки після кліку.
import './calendar-panel.style.scss';

/**
 * Кнопка «Мій календар» у шапці кабінету + сама панель.
 *
 * Панель монтується ЛИШЕ після кліку: на завантаженні сторінки календар нічого
 * не запитує, тож поява кнопки не додає запитів жодній сторінці кабінету.
 *
 * Іконка інлайнова, а не зі спрайта `img/sprites.svg`: спрайт — спільний файл,
 * який паралельно правлять інші підпроекти, і одна кнопка не варта конфлікту в ньому.
 */
const CalendarLauncher = ({ token }) => {
  const [opened, setOpened] = useState(false);
  // Центр кнопки на момент кліку — з нього панель розгортається і в нього ж
  // згортається при закритті.
  const [origin, setOrigin] = useState(null);
  const buttonRef = useRef(null);

  if (!token) {
    return null;
  }

  const open = () => {
    const button = buttonRef.current;

    if (button) {
      const rect = button.getBoundingClientRect();

      setOrigin({ x: rect.left + (rect.width / 2), y: rect.top + (rect.height / 2) });
    }

    setOpened(true);
  };

  return (
    <>
      <button
        type="button"
        ref={buttonRef}
        className={`header-actions__calendar ${opened ? 'is-active' : ''}`}
        aria-label="Мій календар"
        aria-expanded={opened}
        title="Мій календар"
        onClick={open}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <rect x="3" y="5" width="18" height="16" rx="3" />
          <path d="M8 3v4M16 3v4M3 10h18" />
        </svg>
      </button>

      {opened && <CalendarPanel token={token} origin={origin} onClose={() => setOpened(false)} />}
    </>
  );
};

CalendarLauncher.propTypes = {
  token: PropTypes.string,
};

CalendarLauncher.defaultProps = {
  token: '',
};

export default CalendarLauncher;
